import {Injectable} from '@angular/core';
import {Http} from '@angular/http';

import 'rxjs/add/operator/toPromise';

@Injectable()
export class SendMailService {
    private api_url_send_mail = './api/server_mail.php?cmd=SEND_MAIL';

    constructor(private http: Http) {}

    sendMail(action: string, name: string, reference: string, date: string, link: string): Promise<any> {
        return this.http.get(this.api_url_send_mail
            + '&action=' + action
            + '&name=' + name
            + '&reference=' + reference
            + '&date=' + date
            + '&link=' + link
        )
            .toPromise()
            .then(response => response.json() as any)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/send-mail.service.ts